export const stringSorter = (a, b) => {
  const formattedStringA = a ? a.trim().toLowerCase() : ''
  const formattedStringB = b ? b.trim().toLowerCase() : ''
  if(formattedStringA < formattedStringB) return 1
  if(formattedStringA > formattedStringB) return -1
  return 0
}